var _excluded = ["input", "meta"],
  _excluded2 = ["input", "meta", "options", "className", "radioInputProps"];
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import PropTypes from 'prop-types';
import { convertNameToLabel, radioGroupPropTypes, fieldOptionsType, omitLabelProps } from '../helpers';
import { LabeledField } from '../labels';
import { serializeOptions, filterInvalidDOMProps } from '../../utils';

/**
 *
 * A group of radio buttons that can be used in a `redux-form`-controlled form.
 *
 * The value of each radio button is specified via the `options` prop. This prop can either be:
 * - An array of strings
 * - An array of numbers
 * - An array of booleans
 * - An array of key-value pairs: `{ key, value }`, where `key` is a string and `value` is a string, number, or boolean
 *
 * The value of the entire `RadioGroup` component is the value of the currently selected radio button (converted to a string).
 *
 * @name RadioGroup
 * @type Function
 * @param {Object} input - A `redux-form` [input](http://redux-form.com/6.5.0/docs/api/Field.md/#input-props) object
 * @param {Object} meta - A `redux-form` [meta](http://redux-form.com/6.5.0/docs/api/Field.md/#meta-props) object
 * @param {Array} options - An array of radio button values (strings, numbers, booleans, or key-value pairs)
 * @param {Object} [radioInputProps={}] - An object of key-value pairs representing props to pass down to all radio inputs
 * @example
 *
 * function FavoriteFoodForm ({ handleSubmit, pristine, invalid, submitting }) {
 *   return (
 *     <form onSubmit={ handleSubmit }>
 *       <Field
 *          name="favoriteFood"
 *          component={ RadioGroup }
 *          options={[
 *            'Bananas',
 *            'Pineapples',
 *            'Potatoes',
 *          ]}
 *       />
 *       <SubmitButton {...{ pristine, invalid, submitting }}>
 *         Submit
 *       </SubmitButton>
 *     </form>
 *   )
 * }
 *
 * export default FavoriteFoodForm
 *
 * @example
 * function FavoriteFoodForm ({ handleSubmit, pristine, invalid, submitting }) {
 *   return (
 *     <form onSubmit={ handleSubmit }>
 *       <Field
 *          name="favoriteFood"
 *          component={ RadioGroup }
 *          options={[
 *            'Bananas',
 *            'Pineapples',
 *            'Potatoes',
 *          ]}
 *          radioInputProps={{
 *            className: 'radio-input--secondary',
 *          }}
 *       />
 *       <SubmitButton {...{ pristine, invalid, submitting }}>
 *         Submit
 *       </SubmitButton>
 *     </form>
 *   )
 * }
 *
 * export default FavoriteFoodForm
 */

var propTypes = _objectSpread(_objectSpread({}, radioGroupPropTypes), {}, {
  className: PropTypes.string,
  options: fieldOptionsType,
  radioInputProps: PropTypes.object
});
var defaultProps = {
  options: [],
  className: 'RadioGroup',
  radioInputProps: {}
};
function RadioGroupLegend(_ref) {
  var label = _ref.label,
    name = _ref.name;
  if (label === false) return null;
  return /*#__PURE__*/React.createElement("legend", null, label || convertNameToLabel(name));
}

// This should never be used by itself, so it does not exist as a separate export
function RadioButton(props) {
  var _omitLabelProps = omitLabelProps(props),
    _omitLabelProps$input = _omitLabelProps.input,
    id = _omitLabelProps$input.id,
    name = _omitLabelProps$input.name,
    value = _omitLabelProps$input.value,
    onBlur = _omitLabelProps$input.onBlur,
    onChange = _omitLabelProps$input.onChange,
    meta = _omitLabelProps.meta,
    rest = _objectWithoutProperties(_omitLabelProps, _excluded);
  return /*#__PURE__*/React.createElement(LabeledField, props, /*#__PURE__*/React.createElement("div", {
    className: "input-wrapper"
  }, /*#__PURE__*/React.createElement("input", _extends({
    type: "radio",
    id: id,
    name: name,
    value: value,
    onChange: onChange,
    onBlur: onBlur
  }, filterInvalidDOMProps(rest)))));
}
RadioButton.propTypes = _objectSpread({}, radioGroupPropTypes);
function RadioGroup(props) {
  var _omitLabelProps2 = omitLabelProps(props),
    _omitLabelProps2$inpu = _omitLabelProps2.input,
    value = _omitLabelProps2$inpu.value,
    _onChange = _omitLabelProps2$inpu.onChange,
    name = _omitLabelProps2$inpu.name,
    meta = _omitLabelProps2.meta,
    options = _omitLabelProps2.options,
    className = _omitLabelProps2.className,
    radioInputProps = _omitLabelProps2.radioInputProps,
    rest = _objectWithoutProperties(_omitLabelProps2, _excluded2);
  var optionObjects = serializeOptions(options);
  return /*#__PURE__*/React.createElement(LabeledField, _extends({
    className: className,
    labelComponent: RadioGroupLegend
  }, props), optionObjects.map(function (option, i) {
    return /*#__PURE__*/React.createElement(RadioButton // eslint-disable-line react/jsx-key
    , _objectSpread(_objectSpread({
      key: i,
      type: 'radio',
      input: {
        name: name,
        // all radio inputs must share the same name
        value: option.value,
        onChange: function onChange() {
          return _onChange(option.value);
        }
      },
      id: "".concat(name, ".").concat(option.value),
      // override Input default behavior to assign id to input: { name }
      meta: {},
      checked: value === option.value,
      label: option.key
    }, rest), radioInputProps));
  }));
}
RadioGroup.propTypes = propTypes;
RadioGroup.defaultProps = defaultProps;
export default RadioGroup;